import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { CreateCounty } from "../../services/county.service";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import { toUpperCaseName } from "../../utils/helpers";

function AddCounty() {
  const history = useHistory();
  const [disableButton, setDisableButton] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    setDisableButton(true);
    try {
      const result = await CreateCounty({
        name: toUpperCaseName(data.name),
      });

      if (result.success) {
        toast.success(result.message || "County created successfully");
        history.push("/manage-counties");
      } else {
        setDisableButton(false);
        toast.error(result.message || "Failed to create county");
      }
    } catch (error) {
      setDisableButton(false);
      if (error.response?.status == 401) {
        EmptyLocalStorage();
        history.push("/");
      } else {
        toast.error(
          error.response?.data?.message || "Failed to create county"
        );
      }
    }
  };

  return (
    <div className="AddNewUser">
      <h3 className="page-heading">Create County</h3>
      <hr />
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <Form
            className="formAddUser"
            autoComplete="off"
            role="presentation"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row>
              <Col xs={12} sm={12} md={8} lg={4} xl={4}>
                <Form.Group className="mb-3" controlId="name">
                  <Form.Label>County Name</Form.Label>
                  <Form.Control
                    placeholder="Enter County Name"
                    {...register("name", {
                      required: {
                        value: true,
                        message: "County name is required",
                      },
                      minLength: {
                        value: 2,
                        message: "Minimum length is 2",
                      },
                      maxLength: {
                        value: 255,
                        message: "Maximum length is 255",
                      },
                    })}
                    type="text"
                  />
                  {errors.name && (
                    <Form.Text className="text-muted validationText hasError">
                      {errors.name.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={12} md={8} lg={4} xl={4}>
                <input
                  type={"submit"}
                  className={"btn btn-green-theme w-100 mt-3"}
                  disabled={disableButton}
                  value={"Create County"}
                />
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default AddCounty;
